import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bbb868c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-info" }
const _hoisted_2 = { class: "chat-select" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = { class: "members" }
const _hoisted_5 = ["onClick"]

import MobileNavigationBackButton from "@/components/buttons/MobileNavigationBackButton.vue";
import UsersSelectBox from "@/components/select/UsersSelectBox.vue";
import { useComputedValue } from "@/composables";
import { GetterTypes } from "@/store";
import { AppEnvironment } from "@/store/app/state";
import { Profile } from "@/store/auth/state";
import { computed } from "vue";

interface ChatTopBarNewChatProps {
  members: Profile[];
}

interface ChatTopBarNewChatEmits {
  (e: "remove-member", member: Profile): void;
  (e: "add-member", member: Profile): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatTopBarNewChat',
  props: {
    members: { default: () => [] }
  },
  emits: ["remove-member", "add-member"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;
const environment = useComputedValue<AppEnvironment>(
  GetterTypes.GET_APP_ENVIRONMENT,
);
const isMobileApp = computed(() => environment.value.isMobileApp);

const removeMember = (member: Profile) => {
  emit("remove-member", member);
};
const addMember = (member: Profile) => {
  emit("add-member", member);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["chat-top-bar", {
      webview: isMobileApp.value,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(MobileNavigationBackButton),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("chat.chatContainer.ChatTopBarNewChat.label")), 1),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.members, (member) => {
            return (_openBlock(), _createElementBlock("div", {
              key: member.id,
              class: "member",
              onClick: ($event: any) => (removeMember(member))
            }, _toDisplayString(member.name), 9, _hoisted_5))
          }), 128))
        ]),
        _createVNode(UsersSelectBox, { onSetSelectedUsers: addMember })
      ])
    ])
  ], 2))
}
}

})